import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
// The user must replace this config with their actual Firebase project settings
const firebaseConfig = {
  apiKey: "AIzaSyAezbb7F7e9eM3Twr2aft5xIweMWClhGoE",
  authDomain: "devtracker-a46ee.firebaseapp.com",
  databaseURL: "https://devtracker-a46ee-default-rtdb.firebaseio.com",
  projectId: "devtracker-a46ee",
  storageBucket: "devtracker-a46ee.firebasestorage.app",
  messagingSenderId: "72460952952",
  appId: "1:72460952952:web:e08f74ae5b6b2ec435548d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);
